export const REPORT_ORGAN_MAP_HEIGHT_PT = 127.7;
export const REPORT_MEDIA_ITEM_WIDTH_PT = 176;

export interface ReportSectionType {
  type: string;
}

export interface ReportOrganMapSource {
  organMapImageUrl?: string | null;
  organMapTemplateId?: string | null;
}

export interface ReportOrganMapGeometry extends ReportOrganMapSource {
  organMapWidth?: number | null;
  organMapHeight?: number | null;
}

export interface ReportMediaGeometry {
  height?: number | null;
  width?: number | null;
}

export const hasApplicableOrganMap = (
  specimen: ReportOrganMapSource
): boolean => Boolean(specimen.organMapTemplateId && specimen.organMapImageUrl);

export const isOrganMapSection = (section: ReportSectionType): boolean =>
  section.type === "organ_map" || section.type === "diagnostic_map";

const hasRenderedMapGeometry = (
  specimen: ReportOrganMapGeometry
): specimen is ReportOrganMapGeometry & {
  organMapWidth: number;
  organMapHeight: number;
} =>
  Boolean(
    hasApplicableOrganMap(specimen) &&
      specimen.organMapWidth &&
      specimen.organMapHeight &&
      specimen.organMapWidth > 0 &&
      specimen.organMapHeight > 0
  );

const getRenderedMapWidth = (specimen: ReportOrganMapGeometry): number =>
  REPORT_ORGAN_MAP_HEIGHT_PT *
  ((specimen.organMapWidth || 0) / (specimen.organMapHeight || 1));

export function getReportPhotoReferenceWidth(
  specimens: ReportOrganMapGeometry[]
): string {
  const widths = specimens
    .filter(hasRenderedMapGeometry)
    .map(getRenderedMapWidth);
  const widestMap = widths.length > 0 ? Math.max(...widths) : 0;
  return `${Math.min(
    widestMap || REPORT_MEDIA_ITEM_WIDTH_PT,
    REPORT_MEDIA_ITEM_WIDTH_PT
  )}pt`;
}

export function getReportMediaFrameHeight(
  referenceWidth: string,
  geometries: ReportMediaGeometry[]
): string {
  const referenceWidthPt = Number.parseFloat(referenceWidth);
  const renderedHeights = geometries
    .filter(
      (geometry) =>
        geometry.width &&
        geometry.height &&
        geometry.width > 0 &&
        geometry.height > 0
    )
    .map(
      (geometry) =>
        referenceWidthPt * ((geometry.height || 1) / (geometry.width || 1))
    );
  return `${Math.max(REPORT_ORGAN_MAP_HEIGHT_PT, ...renderedHeights)}pt`;
}
